import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { getPreviewProducts } from 'dux/checkoutCart/selectors';

import ProductPreviewAtCart from './ProductPreviewAtCart';
import StyledCartSection from './StyledCartSection';

export const PreviewSection = ({ products }) => {
  return (
    <StyledCartSection>
      <ProductPreviewAtCart products={products} />
    </StyledCartSection>
  );
};

PreviewSection.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})),
};

export default connect(
  state => ({
    products: getPreviewProducts(state),
  }),
  {}
)(PreviewSection);
